
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#account-groups'), APPLICATION._PATH_PREFIX + 'account-group/account-groups', 'AccountGroup', 'accountGroups')        
      }

    },

    // Account groups scripts
    accountGroups:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#account-groups', 'AccountGroup', 'accountGroups')
      }

    }

  }